import countries from 'i18n-iso-countries';

export default function getAllCountryCodes() {
  return Object.keys(countries.getAlpha2Codes());
}
